"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcFileIcon = class UcFileIcon extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    filename;
    onFilename(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("filename");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    assignments;
    ux;
    dataMembers = ['assignments', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                assignments: {
                    default: "vscode-icons:file-type-binary",
                    pdf: "vscode-icons:file-type-pdf2",
                    doc: "vscode-icons:file-type-word",
                    docx: "vscode-icons:file-type-word",
                    xls: "vscode-icons:file-type-excel",
                    xlsx: "vscode-icons:file-type-excel",
                    txt: "vscode-icons:file-type-text",
                    zip: "vscode-icons:file-type-zip2",
                    ps: "vscode-icons:file-type-photoshop2",
                    md: "vscode-icons:file-type-markdown",
                    bmp: "vscode-icons:file-type-image",
                    jpg: "vscode-icons:file-type-image",
                    jpeg: "vscode-icons:file-type-image",
                    avi: "vscode-icons:file-type-video",
                },
                ux: null,
            },
        };
    }
    get extension() {
        if (this.loaded) {
            return this.filename.indexOf('.')
                ? _.last(this.filename.split('.')).toLowerCase()
                : this.filename.slice(1, 3);
        }
        return null;
    }
    get icon() {
        if (this.loaded) {
            return _.get(this.assignments, this.extension, this.assignments.default);
        }
        return null;
    }
    actions;
    getActions() {
        return {};
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcFileIcon.prototype, "filename", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('filename'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFileIcon.prototype, "onFilename", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcFileIcon.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFileIcon.prototype, "onSize", null);
UcFileIcon = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcFileIcon);
exports.default = UcFileIcon;
vue_property_decorator_1.Vue.component("UcFileIcon", UcFileIcon);
